import { AttributeTypeEnum } from "@sinch/core/entities/serverEnums";
import { AttributeTypeEnum as AttributeType } from "@sinch/core/entities/serverEnums.types";
import { ensureArray } from "ramda-adjunct";
import { propEq } from "ramda";
import { match, P } from "ts-pattern";
import { DateTime } from "luxon";

export const parseAttributeValue = (
  dataType: AttributeTypeEnum | AttributeType | null,
  value: any,
  files: { id: string; name: string; url: string }[],
  timeZone: string
) => {
  const valueFiles = ensureArray(value)
    .map((fileID) => files?.find(propEq("id", fileID)) ?? null)
    ?.filter(Boolean) as { id: string; name: string; url: string }[];
  return match(dataType)
    .with(AttributeTypeEnum.Date, () => DateTime.fromSQL(value as string, { zone: timeZone }).toJSDate())
    .with(P.union(AttributeTypeEnum.Gallery, AttributeTypeEnum.Image, AttributeTypeEnum.File), () =>
      ensureArray(valueFiles)
    )
    .otherwise(() => value ?? null);
};

// Reverse of `parseAttributeValue` for the profile-review mutation payload.
// `parseAttributeValue` turns server values into UI-friendly shapes (Date objects
// for dates, [{id,url,name}] for files). Those shapes are NOT what the mutation
// resolver expects — dates need an ISO string, file lists need an array of IDs.
// Without this step the admin's "edited" payload would push parsed objects back
// at the backend and either fail validation or silently overwrite the wrong shape.
export const serializeEditedValue = (
  dataType: AttributeTypeEnum | AttributeType | null,
  value: unknown
): unknown => {
  if (value === null || value === undefined) {
    return null;
  }

  return match(dataType)
    .with(AttributeTypeEnum.Date, () => (value instanceof Date ? DateTime.fromJSDate(value).toISODate() : value))
    .with(P.union(AttributeTypeEnum.Gallery, AttributeTypeEnum.Image, AttributeTypeEnum.File), () => {
      if (!Array.isArray(value)) {
        return value;
      }
      return value.map((file) =>
        file !== null && typeof file === "object" && "id" in file ? (file as { id: string }).id : file
      );
    })
    .otherwise(() => value);
};
